import { useState, useContext, useEffect, useRef } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { Box } from "@mui/material";
import { AmountBox, AppAmountBoxWrapper, FilterNonIdeal } from "../../common";
import { AppPagination } from "../../../Libraries";
import { formatNum } from "../../../oscar-pos-core/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import {
  DEFAULT_DATE_FILTERS_EXPORT,
  ITEMS_PER_PAGE,
  TABLE_FILTER_SALES_UNIFICATION,
} from "../../../constants";
import AppTableFilters from "../../common/AppTableFilters";
import useDownlaodPdf from "../../../hooks/useDownlaodPdf";
import { useFiltersHandler } from "../../../hooks/useFilterHandler";
import withObservables from "@nozbe/with-observables";
import { of } from "rxjs";
import { buildFiltersConfig } from "../../../utils";
import { useAllSaleList } from "../../../hooks/useAllSaleList";
import ItemsList from "./ItemsList";
import SaleListTableHeader from "./AllSaleListTableHeader";
import { navigateToEdit } from "../../Features/NewInvoiceBook/invoiceBookUtils";

const SaleList = ({
  accountWrapperClassName,
  accountListBodyWarpperClassName,
  user,
  business,
  customers,
  initialAllSale,
  quickSaleListCount,
} = {}) => {
  const [pageSize, setPageSize] = useState(0);
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedContactId, setSelectedContactId] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const justClosedDropdownRef = useRef(false);

  const { onDownload, downloadLoading } = useDownlaodPdf(user);

  const {
    filters,
    appliedChips,
    handleFilterChange,
    resetFilters,
    handleRemoveChip,
    isResetFilter,
    setIsResetFilter,
  } = useFiltersHandler(undefined, I18n);

  const {
    SaleList,
    handleAllSales,
    totalSaleFilterCount,
    totalSaleAmount,
    totalPaid,
    totalUnPaid,
    isLoading,
  } = useAllSaleList(initialAllSale, ITEMS_PER_PAGE);

  const initialGetData = () => {
    setPageSize(0);
    handleAllSales({
      business,
      filters,
      offset: 0,
      limit: ITEMS_PER_PAGE,
    });
  };

  useEffect(() => {
    initialGetData();
  }, [filters]);

  const handleGoDetail = (item) => {
    navigate(`/Accounts/AccountDetail/${item.id}`);
  };

  const handleDownloadReport = (startDate, endDate) => {
    triggerLogEvent(analytics, "sale_report_download");
    let paramsForReport = {
      name: "Invoice statement.pdf",
      template_name: "accountreport_new.hbs",
      business_id: business.id,
      start_date: startDate || "",
      end_date: endDate || "",
      type: !filters?.view
        ? "combined"
        : filters.view?.toLowerCase() == "invoice"
          ? "invoice"
          : filters?.view?.toLowerCase() == "pos"
            ? "pos"
            : "expense",
      invoice_type: "sales",
      pdf: true,
    };

    onDownload(paramsForReport, () => {}, navigate);
  };

  return (
    <Box className={accountWrapperClassName || "AccountWrapper"}>
      <AppTableFilters
        filters={TABLE_FILTER_SALES_UNIFICATION}
        onFilterChange={handleFilterChange}
        appliedChips={appliedChips}
        filterState={filters}
        onRemoveChip={(chip) => handleRemoveChip(chip)}
        filtersConfig={buildFiltersConfig(TABLE_FILTER_SALES_UNIFICATION, null, null, null, null, null, null, null, null, I18n)}
        isResetFilter={isResetFilter}
        setIsResetFilter={setIsResetFilter}
        exportConfig={{
          onExport: handleDownloadReport,
          loading: downloadLoading,
          dateFilters: DEFAULT_DATE_FILTERS_EXPORT,
          applyBtnText: I18n.export,
          spinnerColor: "black",
        }}
      />
      <AppAmountBoxWrapper>
        <AmountBox
          data={[
            
            {
              amount: formatNum(totalSaleAmount),
              title: I18n.total_sales,
              id: "total_sales",
              rsLabel: true,
              amountParaTextClassname: "newFontColor",
            },
            {
              amount: formatNum(totalPaid),
              title: I18n.total_paid_sales,
              id: "total_paid_sales",
              rsLabel: true,
              amountParaTextClassname: "newFontColor",
            },
            {
              amount: formatNum(totalUnPaid),
              title: I18n.total_unpaid_sales,
              id: "total_unpaid_sales",
              rsLabel: true,
              amountParaTextClassname: "foundationOrangeColor",
            },

          ]}
        />
      </AppAmountBoxWrapper>

      <SaleListTableHeader
        filters={filters}
        handleFilterChange={handleFilterChange}
        type="in"
        disabled={!SaleList.length}
      />

      <Box
        className={`${accountListBodyWarpperClassName || "accountListBodyWarpper"} generic-scrollbar`}
        id="scrollableDiv"
      >
        {SaleList.length > 0 ? (
          <AppPagination
            data={{
              handleNext: (e) => {
                if (SaleList.length < totalSaleFilterCount) {
                  setPageSize((value) => value + 1);
                  handleAllSales({
                    business,
                    offset: (pageSize + 1) * ITEMS_PER_PAGE,
                    limit: ITEMS_PER_PAGE,
                    filters,
                    isCalculateTotal: false,
                  });
                }
              },
              pageLoad: true,
              count: totalSaleFilterCount,
              list: SaleList,
              scrollableTarget: "scrollableDiv",
            }}
          >
            {SaleList.map((item, index) => (
              <ItemsList
                key={index}
                index={index}
                sale={item}
                business={business}
                contactList={customers}
                onSelect={() => handleGoDetail(item)}
                selectedContactId={selectedContactId}
                setSelectedContactId={setSelectedContactId}
                justClosedDropdownRef={justClosedDropdownRef}
                selectedId={selectedId}
                onEdit={() => {
                  triggerLogEvent(analytics, "quick_sale-edit");
                  let tranType = item?.tranType?.toLowerCase() || "";
                  if (tranType == "bill") {
                    navigateToEdit(
                      navigate,
                      "in",
                      {
                        invoiceId: item.id,
                        customerId: item?.customer?.id || "",
                      },
                      location,
                    );
                  } else {
                    navigate(`/QuickSale/QuickSaleForm/Edit/${item.id}`, {
                      state: {
                        pathname: location.pathname,
                        data: quickSaleListCount,
                      },
                    });
                  }
                }}
                refetchList={() => {
                  initialGetData();
                }}
              />
            ))}
          </AppPagination>
        ) : !isLoading ? (
          <Box className="h-100">
            <FilterNonIdeal
              title={I18n.no_transactions_matching_those_filters}
              subTitle={I18n.try_adjusting_filters}
              subTitleTextOnClick={() => resetFilters()}
              subTitleText={I18n.reset_small}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

const enhance = withObservables(["business"], ({ business }) => {
  return {
    customers: business ? business?.getAllCustomers.observe() : of([]),
    initialAllSale: business
      ? business.getAllSales(undefined, undefined, "").observe()
      : of([]),
  };
});

export default enhance(SaleList);
